import { useNavigate } from "react-router-dom";
import { ArrowLeft, Settings as SettingsIcon, CheckCircle } from "lucide-react";

export default function IntegrationTopBar({ integration }) {
  const navigate = useNavigate();
  const isConnected = integration.status === "Connected";

  return (
    <div className="bg-white border-b border-gray-200 px-8 py-4 flex justify-between items-center">
      {/* Left side - Back button + Logo + Integration name */}
      <div className="flex items-center gap-4">
        <button
          onClick={() => navigate("/dashboard")}
          className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
        >
          <ArrowLeft className="w-5 h-5 text-gray-700" />
        </button>
        <div className="flex items-center gap-3">
          {integration.iconPath ? (
            <img
              src={integration.iconPath}
              alt={`${integration.name} logo`}
              className="w-12 h-12 rounded-xl object-contain bg-white p-2"
            />
          ) : (
            <div className="w-12 h-12 rounded-xl bg-gray-100 flex items-center justify-center">
              <span className="text-lg font-bold text-gray-400">
                {integration.name?.charAt(0).toUpperCase() || "?"}
              </span>
            </div>
          )}
          <div>
            <h1 className="text-xl font-bold text-gray-900">
              {integration.name}
            </h1>
            <p className="text-sm text-gray-600">
              {integration.subtitle || integration.category}
            </p>
          </div>
        </div>
      </div>

      {/* Right side - Connected status + Settings button */}
      <div className="flex items-center gap-3">
        {isConnected && (
          <span className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium">
            <CheckCircle className="w-4 h-4" />
            Connected
          </span>
        )}
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors font-medium">
          <SettingsIcon className="w-4 h-4" />
          Settings
        </button>
      </div>
    </div>
  );
}
